"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "30", height: "30", viewBox: "-46 -4 30 30", className: "Icon toolbar-arrow-right-off", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("path", { d: "M-45.5 12.7V9.5h8.9V5.6l12.7 5.1-12.7 5.9v-3.9h-8.9z", fill: "#777" }),
        _react2.default.createElement("path", { d: "M-17 11c0-7.7-6.3-14-14-14s-14 6.3-14 14 6.3 14 14 14 14-6.3 14-14zm-29 0c0-8.3 6.7-15 15-15s15 6.7 15 15-6.7 15-15 15-15-6.7-15-15z", fill: "#bbb" })
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/toolbar-arrow-right-off.js
// module id = 1872
// module chunks = 0